var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('iframe',{attrs:{"id":"marketReport","width":"100%","frameborder":"no","border":"0","marginwidth":"0","marginheight":"0","scrolling":"no","SameSite":"None","allowtransparency":"yes","src":_vm.showUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }